import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import parse from 'html-react-parser';
import GenericHeader from '@common-components/pageHeader/GenericHeader';

interface IPreOEPLandingProps {
    exchangeName: string;
    phone: string;
}

const PreOEPLanding = ({ exchangeName, phone }: IPreOEPLandingProps) => {
    const intl = useIntl();

    return (
        <Fragment>
            <div className="grid-row gi-panel">
                <GenericHeader
                    id="welcome"
                    text="pre-oep_landing.header"
                    tag="h1"
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                    textReplacements={{
                        exchangeName,
                    }}
                />
                <p>{parse(intl.formatMessage({ id: 'pre-oep_landing.para1' }, { exchangeName }))}</p>
                <p>{parse(intl.formatMessage({ id: 'pre-oep_landing.para2' }, { exchangeName }))}</p>
                <p>{parse(intl.formatMessage({ id: 'pre-oep_landing.para3' }, { exchangeName }))}</p>
            </div>
        </Fragment>
    );
};

export default PreOEPLanding;
